import React from 'react';
import {Button, List, Collaboration, Tag, Popup} from 'components';
import {sortBy, find, pluralize, noop, shorten, useNamedSelector} from 'helpers';
import {role} from 'store/relations';
import css from './share.module.scss';

export function ShareMenu({ id, context, animate, popup }) {
  const collaborators = useNamedSelector('collaborators.list');
  const collaboration = useNamedSelector('relations.collaboration', { id, context });
  const shareable = !collaboration || collaboration.shareable;
  return (
    <div className={css.menu}>
      <Popup.Menu>
        <Popup.Menu.SubHeading>
          { collaborators.confirmed.length ? 'Share with:' : 'You have no collaborators' }
        </Popup.Menu.SubHeading>
        { shareable && collaborators.confirmed.map(collaborator =>
          <Popup.Menu.Item disabled={!shareable} rightIcon={shareable && 'arrow-right'} key={collaborator.id} onClick={popup.redirect(Collaboration.CollaborationMenu, { collaborator, full: true })}>
            <b>{ shorten(collaborator.name || collaborator.email, { chars: collaboration ? 20 : 30 }) }</b>
            { find(collaboration?.relations, {email: collaborator.email}) &&
              <Tag className={css({ appear: animate == collaborator })}>
                { role(find(collaboration?.relations, {email: collaborator.email})) }
              </Tag>
            }
          </Popup.Menu.Item>
        )}
        { collaboration && !shareable && collaboration.relations.map(relation =>
          <Popup.Menu.Item disabled key={relation.serverId}>
            <b>{ shorten(relation.email, { chars: 30 }) }</b>
            <Tag>
              { role(relation) }
            </Tag>
          </Popup.Menu.Item>
        )}
      </Popup.Menu>
      <Popup.Menu onClick={noop}>
        <Popup.Menu.Separator />
        { shareable &&
          <Popup.Menu.AdvanceItem icon="plus" Component={Collaboration.InviteCollaborator}>Invite Collaborator</Popup.Menu.AdvanceItem>
        }
        <Popup.Menu.Item onClick={popup.close} to="/settings/sharing/" icon="settings">Sharing Dashboard</Popup.Menu.Item>
        <Popup.Menu.Item icon="question" onClick={popup.redirect(Help, { context })}>How it works</Popup.Menu.Item>
      </Popup.Menu>
    </div>
  );
}

export function ShareMenuMinimum({ id, context, popup }) {
  const { premium } = useNamedSelector('session.subscription');
  const collaboration = useNamedSelector('relations.collaboration', { id, context });
  const shareable = !collaboration || collaboration.shareable;
  return (
    <div className={css.menu}>
      <Popup.Menu>
        { sortBy(collaboration?.relations, rel => rel.type != 'Owner').map(rel =>
          <Popup.Menu.Item disabled key={rel.serverId}>
            <b>{ shorten(rel.email, { chars: 30 }) }</b>
            <Tag selected={rel.type == 'Owner'}>
              { role(rel) }
            </Tag>
          </Popup.Menu.Item>
        )}
      </Popup.Menu>
      { shareable && premium &&
        <Popup.Menu onClick={noop}>
          <Popup.Menu.Separator />
          <Popup.Menu.Item icon="pencil" onClick={popup.redirect(ShareMenu)}>Edit</Popup.Menu.Item>
        </Popup.Menu>
      }
    </div>
  );
}

function Help({ popup, context }) {
  return (
    <List className={[css.menu, 'small-gutter']}>
      <p>
        <b>Share</b><br />
        <small>Allow other people to see your { pluralize(context, 1) }. They will not be able to make any changes to it.</small>
      </p>
      <p>
        <b>Collaborate</b><br />
        <small>Allow other people to see, edit and update your { pluralize(context, 1) }.</small>
      </p>
      <p>
        <b>Assign</b><br />
        <small>Transfer your { pluralize(context, 1) } to another person. He / she will become the new owner of the { pluralize(context, 1) }. You will be able to see it, but will not be able to edit and update it anymore.</small>
      </p>
      <p className="text-right">
        <Button onClick={popup.redirect(ShareMenu)} icon="check">Ok</Button>
      </p>
    </List>
  );
}
